import * as React from 'react'

import {
  makeStyles,
  Button,
  Card,
  Checkbox,
  Input,
  Label
} from '@fluentui/react-components'
import { DatePicker } from '@fluentui/react-datepicker-compat'

import { CHECKBOX_COMPONENTS, FILTER_DATEPICKER_COMPONENTS, FILTER_INPUT_COMPONENTS } from '../constants/search'

import style from '../styles/filter-panel'

const useStyles = makeStyles(style)

const FilterPanel = ({
  filterInputs,
  setFilterInputs
}) => {
  const classes = useStyles()

  const onFormatDate = (date) => {
    return !date
      ? ''
      : date.getDate() +
        '/' +
        (date.getMonth() + 1) +
        '/' +
        date.getFullYear()
  }

  const onChangeInput = (e, data) => {
    setFilterInputs((prevState) => ({
      ...prevState,
      [e.target.name]: data.value
    }))
  }

  const onSelectDate = (date, inputName) => {
    setFilterInputs((prevState) => ({
      ...prevState,
      [inputName]: date
    }))
  }

  const onChangeCheckbox = (e, data) => {
    setFilterInputs((prevState) => ({
      ...prevState,
      [e.target.name]: data.checked
    }))
  }

  const resetFilters = () => {
    setFilterInputs({
      from: '',
      to: '',
      subject: '',
      body: '',
      dateFrom: null,
      dateTo: null,
      hasAttachments: false
    })
  }

  return (
    <Card className={classes.filterPanelContainer}>
      <div className={classes.filterPanel}>
        {FILTER_INPUT_COMPONENTS.map((item) => {
          return (
            <div
              className={classes.row}
              key={item.name}
            >
              <Label
                className={classes.label}
                htmlFor={item.name}
                weight='semibold'
              >
                {item.label}
              </Label>
              <Input
                className={classes.input}
                id={item.name}
                appearance='underline'
                onChange={onChangeInput}
                name={item.name}
                value={filterInputs[item.name] ?? ''}
              />
            </div>
          )
        })}
        <div className={classes.row}>
          <Label
            className={classes.label}
            weight='semibold'
          >
            {FILTER_DATEPICKER_COMPONENTS.LABEL}
          </Label>
          <div className={classes.datePickerRow}>
            {FILTER_DATEPICKER_COMPONENTS.COMPONENTS.map((item) => (
              <DatePicker
                className={classes.datePickerInput}
                key={item.name}
                placeholder={item.placeholder}
                isMonthPickerVisible={item.isMonthPickerVisible}
                formatDate={onFormatDate}
                onSelectDate={(date) => onSelectDate(date, item.name)}
                name={item.name}
                value={filterInputs[item.name] ?? null}
              />
            ))}
          </div>
        </div>
        {CHECKBOX_COMPONENTS.map((item) => (
          <div className={classes.row} key={item.name}>
            <Label
              className={classes.label}
              htmlFor={item.name}
              weight='semibold'
            >
              {item.label}
            </Label>
            <Checkbox
              id={item.name}
              name={item.name}
              checked={!!filterInputs[item.name]}
              onChange={onChangeCheckbox}
            />
          </div>
        ))}
        <Button onClick={resetFilters}>Reset filters</Button>
      </div>
    </Card>
  )
}

export default FilterPanel
